<template>
    <div class="speech-model-wrap" @click="ClickSpeecher">
        <div class="container">
            <img class="photo" :src="img">
            <div class="card-content">
                <div class="name">{{ name }}</div>
                <div class="type">{{ type }}</div>
            </div>           
            <i v-show="check" class="iconfont icon-success"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: "SpeechModel",
    props:["id","img","name","type","mycheck"],
    computed:{
    check(){
        return this.mycheck
    }
   },
    methods: {
    ClickSpeecher()
    {  
        this.$emit("Choosethis",this.id);
    },
},

}
</script>

<style scoped>
    .speech-model-wrap {
        transition: transform 0.2s ease;
    }
    .speech-model-wrap:hover .container {
        border-color: #409EFF;
        box-shadow: 0 2px 8px rgba(64, 158, 255, 0.2);
    }
    .speech-model-wrap:hover {
        transform: scale(1.02);
    }
    .speech-model-wrap:active {
        transform: scale(0.98);
    }
    @media(min-width: 769px){
        .container{
            margin-right: 10px;
            margin-bottom: 10px;
            padding-left: 15px;
            width: 159px;
            height: 80px;
            display: flex;
            align-items: center;
            border:1px solid #DEDEDE;
            position: relative;
            cursor: pointer;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;
        }
        .photo{
            border:1px solid #DEDEDE;
            border-radius: 50%;
            width: 35px;
            height: 35px;
        }
        .card-content{
            margin-left: 8px;        
            font-size: 14px;
            color: rgb(51, 51, 51);
        }
        .name,.type{
            height: 25px;
            line-height: 25px;
        }
        .iconfont{
            font-size: 24px;
            position: absolute;
            top:10px;
            right:10px;
            color: rgb(0, 112, 204); 
        }
    }
    @media(max-width: 768px){
        .container{
            margin-right: 1vw;
            margin-bottom:1vw;
            padding-left: 1vw;
            width: 30vw;
            height: 8vh;
            display: flex;
            align-items: center;
            border:1px solid #DEDEDE;
            position: relative;
            cursor: pointer;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;
        }
        .photo{
            border:1px solid #DEDEDE;
            border-radius: 50%;
            width:8vw;
            height: 8vw;
        }
        .card-content{
            margin-left: 2vw;        
            font-size: 14px;
            color: rgb(51, 51, 51);
        }
        .name,.type{
            height: 3vh;
            line-height: 3vh;
        }
        .iconfont{
            font-size: 24px;
            position: absolute;
            top:10px;
            right:10px;
            color: rgb(0, 112, 204); 
        }
    }
</style>

<!-- 暗黑模式适配 -->
<style>
.dark-mode .speech-model-wrap .container {
    border-color: var(--border-color) !important;
    background: var(--bg-card);
}
.dark-mode .speech-model-wrap .card-content {
    color: var(--text-regular) !important;
}
.dark-mode .speech-model-wrap .photo {
    border-color: var(--border-color) !important;
}
.dark-mode .speech-model-wrap:hover .container {
    border-color: #409EFF !important;
    box-shadow: 0 2px 8px rgba(64, 158, 255, 0.3) !important;
}
</style>